export const formatKeywords = (keywords) => (keywords || []).join(', ');

export const parseKeywords = (text) => {
  if (!text?.trim()) return [];
  return text.split(', ').map((item) => item.trim()).filter(Boolean);
};
